import { Box, Chip, Stack, Typography } from '@mui/material'
import MdPhone from '@mui/icons-material/Phone'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import React from 'react'
import { ACOR_TELEFONE, ACOR_WHATSAPP } from 'services/utils'
import Loading from 'Components/Loading'
//import { Link } from 'react-router-dom'

export const CentralAgendamento = () => {
    const onPhone = () => {
        window.open(ACOR_TELEFONE)
    }

    const onWhatsapp = () => {
        window.open(ACOR_WHATSAPP)
    }

    const ButtonWhatsapp = () => {
        return <Chip 
            onClick={onWhatsapp}
            icon={<WhatsAppIcon color={'#d5272d'}  />} label={'Whatsapp'} sx={{ 
            ".MuiChip-icon": {
                color: '#d5272d'
            },
            color: '#d5272d',
            bgcolor: 'transparent',
            border: '1px solid #d5272d',
            padding: '30px',
            minWidth: '100%',
            borderRadius: '50px',
            margin: '7px 0',
        }} />
    }

    const ButtonPhone = () => {
        return <Chip 
            onClick={onPhone}
            icon={<MdPhone />} label={'Telefone'} sx={{ 
                ".MuiChip-icon": {
                color: '#d5272d'
                },
                color: '#d5272d',
                bgcolor: 'transparent',
                border: '1px solid #d5272d',
                padding: '30px',
                minWidth: '100%',
                borderRadius: '50px',
                margin: '7px 0',
            }}
            variant={'outlined'}

        />
    }

    return (
        
        <Box >
            <Stack sx={{
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    flexDirection: 'column',
                }}
            >
                <div >
                    <Typography 
                        variant="h3" 
                        spacing={4} 
                        component="h1"
                        py={2}
                        flex={1} 
                        sx={{
                            fontSize:
                            {
                                sm: '1.7rem', xs: '1.7rem' 
                            }
                        }}
                    >Central de Agendamento</Typography>  
                </div>         
                <Stack mt={2}>
                
                    <Stack sx={{ padding: '20px 0', textAlign: {sm: 'center', xs: 'center'}} }>
                        <Typography 
                            variant="p" 
                            //color={'error'}
                            component="p"
                            fontSize={'14px'}
                            
                        >Desculpe ocorreu um problema em nosso cadastro. </Typography>
                        <Typography 
                            variant="p" 
                            //color={'error'}
                            component="p"
                            fontSize={'14px'}
                        >
                        Para continuarmos seu agendamento, favor entrar em contato com nossa Central de Agendamento.
                        </Typography>
                    </Stack>

                    <ButtonPhone />
                    <ButtonWhatsapp />
                </Stack>
                
            </Stack>  
            
        </Box>
       
    )
}

const DefaultCentralAgendamento = () => {

    React.useLayoutEffect( () => {
        const site_url = process.env.REACT_APP_SITE_URL
        const onRedirect = () => { 
            window.open(`https://${site_url}/agendamento-web-2`, "_self") 
        }
        onRedirect()
    }, [])

    return <Loading />
}



export default DefaultCentralAgendamento